<div class="step-container col-xs-12"
     [ngClass]="{'recording': showRecordButton() && isVerticalDirection()}">

    <div class="vertical-step" [ngClass]="{'ht-125':(isShowTai || glossaryService.isGlossaryOpened() || quizService.isQuizActive())}" *ngIf="isVerticalDirection()">

        <!-- Top half of step container (needed here for circle to overlap containers) -->
        <div class="row vertical-step-top" [ngClass]="{'border-radius-bottom':(isShowTai || glossaryService.isGlossaryOpened() || quizService.isQuizActive())}">
        </div>

        <!-- Bottom half of step container -->
        <div *ngIf="!(isShowTai || glossaryService.isGlossaryOpened() || quizService.isQuizActive())" class="row vertical-step-bottom">
            <div class="divider-line"></div>
            <!-- Step 1 Buttons -->
            <div [hidden]="!previewStepActive" class="container vertical-step1-bottom">
                <div class="btn-group">
                    <div class="step-button" *ngIf="!isReading()">
                        <button (click)="readSelection()"
                                [disabled]="questionInProgress || readToMeDisabled()"
                                class="btn btn-play">
                        </button>
                        <div class="step-btn-label">Read to Me</div>
                    </div> 

                    <div class="step-button" *ngIf="isReading()">
                        <button (click)="pauseReading()"
                                class="btn btn-pause">
                        </button>
                        <div class="step-btn-label">Pause</div>
                    </div>

                </div>
            </div>

            <!-- Step 2 Buttons -->
            <div [hidden]="!readAndRecordStepActive" class="vertical-step2-bottom">
                <div class="btn-group">

                    <div class="active-action-btns fluency-play-group" [ngClass]="{'record-inactive':playMyReadingDisabled()}">
                        <button (click)="readSelection()"
                                *ngIf="!isReading()"
                                [disabled]="readToMeDisabled()"
                                class="btn btn-play">
                        </button>
                        <div  *ngIf="!isReading()" 
                              class="step-btn-label">Read to Me</div>
                        <button (click)="pauseReading()"
                            class="btn btn-pause"
                            *ngIf="isReading()">
                        </button>
                        <div class="step-btn-label"
                             *ngIf="isReading()">Pause</div>
                    </div>

                    <div class="active-action-btns play-my-recording-group" *ngIf="!playMyReadingDisabled()">
                        <button (click)="readMyRecording()"
                                [disabled]="playMyReadingDisabled()"
                                *ngIf="!isReadingMyRecording()"
                                class="btn btn-play-start">
                        </button>
                        <div class="step-btn-label"
                             *ngIf="!isReadingMyRecording()">
                             Play My Recording
                        </div>
                        <button (click)="pauseReading()"
                            class="btn btn-pause"
                            *ngIf="isReadingMyRecording()">
                        </button>
                        <div  class="step-btn-label"
                              *ngIf="isReadingMyRecording()">Pause</div>
                    </div>
                </div>

            </div>

             <!-- Quiz Button -->
            <div [hidden]="!quizStepActive" class="container vertical-step3-bottom">

                <div class="btn-group btn-group-sm start-btn-block">
                    <button class="btn btn-play-start" (click)="startQuiz()"
                            [disabled]="quizBtnDisabled() || quizService.isQuizActive()">
                    </button>
                    <div class="step-btn-label">{{quizButtonLabel}} </div>
                </div>
            </div>



        </div>

        <!-- Circle Progress Area of step container -->
        <div class="container" *ngIf="isVerticalDirection()">
            <div class="step-circle-row row">

                <!-- Step 1 -->
                <div class="vertical-step-1 circleContainer"
                     [ngClass]="showStepOneVerticalSelectors()"
                (click)="!previewStepActive && goToPreviewStep()">

                    <step-circle  [progress]="previewProgressValue"
                                  [stepActive]="previewStepActive"
                                  [stepAllowed]="previewStepAllowed"
                                  [entries]="parseQuestionStates(questionService.retrieveTAQs())"
                                  [smaller]="true"
                                  [complete]="userModelService.taqCompletionState">
                    </step-circle>

                    <div class="circle-step"
                         [ngClass]="{'disabled': isStepOneCircleDisabled(showCountdown),'completed-circle':isStepComplete('preview') && !previewStepActive}">
                        <div class="step-count" *ngIf="!previewStepActive" [innerText]="1"></div>
                        <div class="preview-progress-badge"
                              *ngIf="previewStepActive"
                             [ngClass]="getCurrentProgressBadge('preview')">
                        </div>

                        <div class="preview-progress-badge mini-version"
                            *ngIf="passMiniVersionRule('preview')  && !previewStepActive"
                            [ngClass]="getCurrentProgressBadge('preview')">
                        </div>
                    </div>
                   

                </div>

                <!-- Step 2 -->
                <div class="vertical-step-2 col-sm-2 circleContainer" [ngClass]="{'col-sm-5': readAndRecordStepActive, 'col-sm-2': !readAndRecordStepActive,
                'minimum': !readAndRecordStepActive, 'completed':userModelService.recordCompletionState }"
                (click)="!readAndRecordStepActive && goToReadAndRecordStep()">

                    <step-circle  [progress]="readAndRecordProgressValue"
                                  [stepActive]="readAndRecordStepActive"
                                  [entries]="fluencyBars"
                                  [stepAllowed]="readAndRecordStepAllowed"
                                  [complete]="userModelService.recordCompletionState">
                    </step-circle>

                    <div class="circle-step"
                        [ngClass]="{'blink': stepService.stepTwoStartBlinking,
                                    'disabled': isStepTwoCircleDisabled(showCountdown), 'completed-circle':isStepComplete('fluency') && !readAndRecordStepActive}">
                        <div class="step-count" *ngIf="!readAndRecordStepActive" [innerText]="2"></div>
                        <div class="recording-btn-group"
                             *ngIf="readAndRecordStepActive">
                            <button (click)="recordSelection()"
                                    [disabled]="recordBtnDisabled()"
                                    *ngIf="!showRecordButton()"
                                    class="btn btn-record">
                            </button>
                           
                            <button (click)="pauseRecording()"
                                    *ngIf="showRecordButton()"
                                    [disabled]="stepService.isCountdownOn"
                                    class="btn btn-record-pause">
                            </button>
                           
                        </div>

                        <div class="fluency-progress-badge"
                             *ngIf="readAndRecordStepActive"
                             [ngClass]="getCurrentProgressBadge('fluency')">
                        </div>

                        <div class="fluency-progress-badge mini-version"
                            *ngIf="passMiniVersionRule('fluency') && !readAndRecordStepActive "
                            [ngClass]="getCurrentProgressBadge('fluency')">
                        </div>

                    </div>
                </div>

                <!-- Step 3 -->
                <div class="vertical-step-3 col-sm-2 circleContainer" [ngClass]="{'col-sm-5': quizStepActive, 'col-sm-2': !quizStepActive, 'minimum': !quizStepActive}"
                (click)="!quizStepActive && goToQuizStep()">

                    <step-circle  [progress]="quizProgressValue"
                                  [stepActive]="quizStepActive"
                                  [stepAllowed]="quizStepAllowed"
                                  [entries]="parseQuestionStates(questionService.retrieveQuiz())"
                                  [smaller]="true"
                                  [complete]="userModelService.quizCompletionState">
                    </step-circle>

                    <div class="circle-step"
                        [ngClass]="{'blink': stepService.stepThreeStartBlinking,
                                    'disabled': startedReadOrRecordActivity(),'completed-circle':isStepComplete('quiz') && !quizStepActive}">
                        <div class="step-count" *ngIf="!quizStepActive" [innerText]="3"></div>
                        <div class="quiz-progress-badge"
                             *ngIf="quizStepActive"
                             [ngClass]="getCurrentProgressBadge('quiz')">
                        </div>

                        <div class="quiz-progress-badge mini-version"
                            *ngIf="passMiniVersionRule('quiz') && !quizStepActive"
                            [ngClass]="getCurrentProgressBadge('quiz')">
                        </div>
                    </div>
                </div>


            </div>
        </div>

    </div>

    <!-- Bottom of iPad Portrait View -->
    <div class="horizontal-step container-fluid" *ngIf="isHorizontalDirection()">

        <div class="row">

            <div class="horizontal-step-bar">
                <div class="row no-left-margin">

                    <div class="horizontal-step-bar-preview"
                         [ngClass]="{'active-step' : previewStepActive, 'step-circles' : !previewStepActive,'completed':isStepComplete('preview')}"
                         (click)="!previewStepActive && goToPreviewStep()">
                        <div class="preview-progress-badge mini-version"
                              *ngIf="passMiniVersionRule('preview')  && !previewStepActive"
                             [ngClass]="getCurrentProgressBadge('preview')"
                              >
                        </div>

                        <div class="active-step-circles"
                             (click)="!previewStepActive && goToPreviewStep()"
                             [ngClass]="{'disabled': isStepOneCircleDisabled(showCountdown),'step-active': previewStepActive,
                                       'completed-circle':isStepComplete('preview') && !previewStepActive}">
                            <div class="step-count" [innerText]="1"></div>
                        </div>
                        <div class="active-action-btns" *ngIf="previewStepActive">
                            <button (click)="readSelection()"
                                    *ngIf="!isReading()"
                                    [disabled]="questionInProgress || readToMeDisabled()"
                                    class="btn btn-play">
                                <span class="step-button">
                                    <label class="step-btn-label">Read to Me</label>
                                </span> 
                            </button>  
                           

                            <button (click)="pauseReading()"
                                    class="btn btn-pause"
                                    *ngIf="isReading()">
                                    <span class="step-button">
                                        <label class="step-btn-label">Pause</label>
                                    </span>
                            </button>
                        </div>
                        <div class="active-step-progress progress-preview" *ngIf="previewStepActive && iconForTAIIsRegularSize()">
                            <!-- the line below works, but the getQuestionsTAIs() call fails even if it returns the exact same object -->
                            <!--<div *ngFor="let question of [{'regular-progress-icon': true, 'active': false}]"-->
                            <!--<div *ngFor='let question of getQuestionTAIs()'-->
                            <div *ngFor='let isActive of getTAIStates();'
                                 class="btn preview-progress-tai"
                                [ngClass]="{'regular-progress-icon': true, 'active': isActive}">
                            <!--[ngClass]="getQuestionClass(0)">-->
                            </div>
                        </div>
                        <div class="active-step-progress progress-preview" *ngIf="previewStepActive && !iconForTAIIsRegularSize()">
                            <div *ngFor='let isActive of getTAIStates();'
                                 class="btn preview-progress-tai"
                                 [ngClass]="{'small-progress-icon': true, 'active': isActive}">
                            </div>
                        </div>
                    </div>

                    <div class="horizontal-step-bar-fluency"
                         [ngClass]="{'active-step' : readAndRecordStepActive, 'step-circles' : !readAndRecordStepActive, 'completed':isStepComplete('fluency'),
                                    'blink': stepService.stepTwoStartBlinking}"
                         (click)="!readAndRecordStepActive && goToReadAndRecordStep()">
                         <div class="fluency-progress-badge mini-version"
                                 *ngIf="passMiniVersionRule('fluency') && !readAndRecordStepActive "
                                 [ngClass]="getCurrentProgressBadge('fluency')">
                         </div>

                        <div class="active-step-circles"
                            [ngClass]="{'disabled': isStepTwoCircleDisabled(showCountdown),'step-active': readAndRecordStepActive,
                                        'completed-circle':isStepComplete('fluency') && !readAndRecordStepActive}"
                            (click)="!readAndRecordStepActive && goToReadAndRecordStep()">
                            <div class="step-count" [innerText]="2"></div>
                         </div> 
                            <div class="active-action-btns fluency-play-group" *ngIf="readAndRecordStepActive">
                                <button (click)="readSelection()"
                                        [disabled]="readToMeDisabled()"
                                        *ngIf="!isReading()"
                                        class="btn btn-play">
                                </button>
                                <span class="step-button" *ngIf="!isReading()">
                                    <label class="step-btn-label">Read to Me</label>
                                </span> 

                                <button (click)="pauseReading()"
                                    class="btn btn-pause"
                                    *ngIf="isReading()"> 
                                </button>
                                <span class="step-button" *ngIf="isReading()">
                                    <label class="step-btn-label">Pause</label>
                                </span>

                                <span class="fluency-recording-group" *ngIf="!playMyReadingDisabled()">
                                    <button (click)="readMyRecording()"
                                        [disabled]="playMyReadingDisabled()"
                                        *ngIf="!isReadingMyRecording()"
                                        class="btn btn-play-start">
                                    </button>
                                    <span class="step-button" *ngIf="!isReadingMyRecording()">
                                        <label class="step-btn-label"> Play My Recording</label>
                                    </span>
                            
                                    <button (click)="pauseReading()"
                                        class="btn btn-pause"
                                        *ngIf="isReadingMyRecording()">
                                    </button>
                                    <span class="step-button"  *ngIf="isReadingMyRecording()">
                                        <label class="step-btn-label"> Pause</label>
                                    </span>
                                </span>
                                
                            </div>
                       
                        <div class="active-step-progress progress-fluency" *ngIf="readAndRecordStepActive"
                        [ngClass]="{'recording': showRecordButton()}">

                            <button class="btn fluency-record-btn"
                                    (click)="recordSelection()"
                                    [disabled]="recordBtnDisabled()"
                                    *ngIf="!showRecordButton()">
                            </button>

                            <button class="btn fluency-pause-record-btn"
                                    (click)="pauseRecording()"
                                    [disabled]="stepService.isCountdownOn"
                                    *ngIf="showRecordButton()">
                            </button>

                            <div class="fluency-progress-bars row">
                                <span *ngFor="let fluency of fluencyBars"
                                    class="fluency-progress-bar"
                                    [ngClass]="fluency"></span>
                            </div>

                        </div>
                       
                    </div>

                    <div class="horizontal-step-bar-quiz
                                step-circles"
                         [ngClass]="{'active-step' : quizStepActive, 'step-circles' : !quizStepActive, 'completed':isStepComplete('quiz'),
                                     'blink': stepService.stepThreeStartBlinking} "
                         (click)="!quizStepActive && goToQuizStep()">
                        <div class="quiz-progress-badge mini-version"
                             *ngIf="passMiniVersionRule('quiz') && !quizStepActive"
                             [ngClass]="getCurrentProgressBadge('quiz')">
                        </div>

                        <div class="active-step-circles"
                        [ngClass]="{'disabled': startedReadOrRecordActivity(),'step-active': quizStepActive,
                                    'completed-circle':isStepComplete('quiz') && !quizStepActive }"
                        (click)="!quizStepActive && goToQuizStep()">
                        <div class="step-count" [innerText]="3"></div>
                        </div>

                        <div class="row quiz-progress-section" *ngIf="quizStepActive">

                            <div class="btn-group btn-group-sm start-btn-block">
                                <button class="btn blue-button btn-lg" (click)="startQuiz()"
                                        [disabled]="quizBtnDisabled() || quizService.isQuizActive()">
                                        <span class="step-btn-label">{{quizButtonLabel}} </span>
                                </button>
                                
                            </div>
                        </div>

                        <div class="active-step-progress progress-quiz" *ngIf="quizStepActive && iconForQuizIsRegularSize()">
                            <div *ngFor='let isActive of getQuizStates();'
                                 class="quiz-progress"
                                 [ngClass]="{'regular-progress-icon': true, 'active': isActive}">
                            </div>
                        </div>
                        <div class="active-step-progress progress-preview" *ngIf="quizStepActive && !iconForQuizIsRegularSize()">
                            <div *ngFor='let isActive of getQuizStates();'
                                 class="preview-progress-tai"
                                 [ngClass]="{'small-progress-icon': true, 'active': isActive}">
                            </div>
                        </div>

                    </div>

                </div>
            </div>

        </div>

    </div>

</div>
